import React from "react";
import { Link } from "react-router-dom";
import "./LegalPage.css";

function PrivacyPolicy() {
  return (
    <div className="legal-page">
      <div className="legal-card">
        <Link to="/register" className="legal-back-link">
          ← Back to registration
        </Link>

        <h1>Privacy Policy</h1>

        <p className="legal-version">
          Current version: 2026-08-17
        </p>

        <section>
          <h2>Placeholder Privacy Policy</h2>
          <p>
            This page is reserved for your Privacy Policy. Replace this
            placeholder text with your official privacy policy.
          </p>
        </section>

        <section>
          <h2>Personal Data</h2>
          <p>
            The service may process account and profile information such as
            email, nickname, age, gender, country, city, and bio.
          </p>
        </section>

        <section>
          <h2>Consent Records</h2>
          <p>
            The service records the version of the terms accepted by the user
            and the server-side timestamp of acceptance.
          </p>
        </section>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
